import { render, staticRenderFns } from "./SubstituteHolidayFrom.vue?vue&type=template&id=28e89deb"
import script from "./SubstituteHolidayFrom.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubstituteHolidayFrom.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports